angular.module('unergie.main')
.controller('resultModalCtrl', ($scope, $uibModalInstance, result) => {
    $scope.result = result.toJSON ? result.toJSON() : result
    $scope.close = $uibModalInstance.close
})
